{
  "currency": "JOD",
  "side": {
    "OWES": "Owes",
    "OWED": "Is owed"
  },
  "kinds": {
    "DEBIT": "Debit",
    "CREDIT": "Credit",
    "MIGRATED": "Migrated movement",
    "MIGRATED_ADJUSTMENT": "Migrated adjustment"
  },
  "badges": {
    "migrated": "Migrated",
    "adjustment": "Migrated adjustment",
    "edited": "Edited",
    "editedBy": "Updated by {{name}}, {{time}}"
  },
  "balanceStatus": {
    "label": "Balance status",
    "OWES": "Has a balance",
    "OWED": "In credit",
    "ZERO": "Zero balance"
  },
  "linkStatus": {
    "label": "Customers link",
    "LINKED": "Linked",
    "PENDING": "Awaiting link",
    "INVALID_PHONE": "Invalid number"
  },
  "messageStatus": {
    "label": "Message status",
    "PENDING": "Queued",
    "SENT": "Sent",
    "DELIVERED": "Delivered",
    "READ": "Read",
    "FAILED": "Failed",
    "INVALID_PHONE": "Invalid number",
    "resend": "Resend message"
  },
  "columns": {
    "number": "Number",
    "reference": "Reference number",
    "occurredAt": "Transaction date",
    "customer": "Customer",
    "name": "Customer name",
    "phone": "Phone number",
    "branch": "Branch",
    "statement": "Statement",
    "debit": "Debit",
    "credit": "Credit",
    "balance": "Balance",
    "debtLimit": "Debt limit",
    "linkStatus": "Customers link",
    "employee": "Employee",
    "notes": "Notes",
    "messageStatus": "Message status",
    "createdBy": "Created by",
    "createdAt": "Created at",
    "updatedBy": "Updated by",
    "updatedAt": "Updated at",
    "deletedAt": "Deleted at",
    "deletedBy": "Deleted by",
    "lastMovementAt": "Last movement date",
    "kind": "Movement type",
    "amount": "Amount",
    "actions": "Actions",
    "account": "Account",
    "accountName": "Account name",
    "accountCount": "Number of accounts"
  },
  "totals": {
    "debit": "Total debit",
    "credit": "Total credit",
    "net": "Balance",
    "count": "Number of movements",
    "overall": "Total",
    "countOf": "({{value}})"
  },
  "filters": {
    "allBranches": "All branches",
    "branch": "Branch",
    "kind": "Movement type",
    "employee": "Employee",
    "customer": "Customer",
    "customerSearch": "Search by name, phone or number...",
    "account": "Account",
    "allAccounts": "All accounts",
    "allKinds": "All types",
    "allCustomers": "All customers",
    "allEmployees": "All employees",
    "allStatuses": "All statuses"
  },
  "export": {
    "excel": "Export to Excel",
    "pdf": "Export PDF",
    "exporting": "Exporting..."
  },
  "overview": {
    "title": "Overview",
    "cards": {
      "debtors": "Number of debtors",
      "totalDebit": "Total debit amount",
      "totalCredit": "Total credit amount",
      "todayDebit": "Total debit amount today",
      "todayCredit": "Total credit amount today",
      "periodDebit": "Total debit amount in the period",
      "periodCredit": "Total credit amount in the period"
    },
    "latest": "Latest movements"
  },
  "accounts": {
    "title": "Debtors",
    "add": "Add customer",
    "editCustomer": "Edit customer",
    "addAccount": "Add account",
    "statement": "Customer statement",
    "searchLabel": "Search by name, phone or number",
    "searchPlaceholder": "Search by name, phone or number...",
    "rowActionsTrigger": "Actions for {{name}}",
    "fields": {
      "name": "Customer name",
      "phone": "Phone number",
      "countryCode": "Country code",
      "branch": "Branch",
      "debtLimit": "Debt limit",
      "accountName": "Account name"
    },
    "drawer": {
      "createDescription": "Enter the new customer's details.",
      "editDescription": "Edit the customer's details. The balance cannot be edited here.",
      "branchPlaceholder": "Select a branch...",
      "addAccountForCustomer": "Add an account for this customer",
      "viewCustomer": "View customer"
    },
    "toasts": {
      "created": "Customer created successfully",
      "updated": "Customer updated successfully"
    }
  },
  "account": {
    "add": "Add account",
    "edit": "Edit account",
    "statement": "Account statement",
    "rowActionsTrigger": "Actions for account {{name}}",
    "drawer": {
      "createDescription": "Enter the new account's details for customer {{name}}.",
      "editDescription": "Edit the account's details. The balance cannot be edited here.",
      "accountPlaceholder": "Select an account..."
    },
    "toasts": {
      "created": "Account created successfully",
      "updated": "Account updated successfully",
      "deleted": "Account deleted successfully"
    },
    "deleteDialog": {
      "title": "Delete account?",
      "description": "Account {{account}} number {{number}} of customer {{customer}} and its movements will move to the trash."
    }
  },
  "customer": {
    "totalBalance": "Total balance",
    "tabs": {
      "accounts": "Accounts",
      "statement": "Customer statement"
    },
    "accountBalances": "Account balances"
  },
  "statement": {
    "title": "Account statement",
    "back": "Back to debtors",
    "currentBalance": "Current balance",
    "addMovement": "Add movement",
    "previousBalance": "Previous balance",
    "rowActionsTrigger": "Actions for movement {{number}}",
    "details": "View Details",
    "deleteDialog": {
      "title": "Delete Confirmation",
      "description": "Are you sure you want to delete movement {{number}}? Later balances will be recalculated."
    },
    "toasts": {
      "deleted": "Movement deleted successfully"
    }
  },
  "movement": {
    "createTitle": "Add movement",
    "editTitle": "Edit movement",
    "description": "{{name}} ({{number}})",
    "fields": {
      "kind": "Movement type",
      "amount": "Amount",
      "occurredAt": "Transaction date",
      "statement": "Statement",
      "notes": "Notes",
      "account": "Account"
    },
    "currentBalance": "Current balance",
    "balanceAfter": "Balance after the movement",
    "laterMovements": "The balance of {{count}} later movements will be recalculated",
    "toasts": {
      "created": "The movement was added successfully",
      "updated": "Movement updated successfully"
    }
  },
  "reports": {
    "title": "Reports",
    "tabs": {
      "statement": "Customer statement",
      "periodMovements": "Period movements",
      "customerBalances": "Customer balances"
    },
    "statementPicker": {
      "customer": "Customer",
      "open": "View",
      "account": "Account"
    },
    "branchTotals": "Branch"
  },
  "trash": {
    "title": "Trash",
    "type": "Type",
    "types": {
      "MOVEMENTS": "Movements",
      "ACCOUNTS": "Accounts"
    },
    "restore": "Restore",
    "rowActionsTrigger": "Actions for record {{number}}",
    "restoreDialog": {
      "title": "Restore the record?",
      "movement": "Movement {{number}} will be restored and later balances recalculated.",
      "account": "Account {{account}}, number {{number}}, of customer {{customer}} will be restored with its movements."
    },
    "toasts": {
      "restored": "Record restored successfully"
    }
  },
  "linkError": {
    "PHONE_REJECTED": "Customers refused this number; edit the phone",
    "VERIFICATION_EXPIRED": "The phone verification expired. Verify again",
    "reverify": "Verify again"
  },
  "profile": {
    "bannerTitle": "Customer details are incomplete",
    "bannerText": "Debit and credit movements on this customer's accounts are stopped until the details are completed.",
    "issues": {
      "NAME_MISSING": "The customer name is required",
      "NAME_INVALID": "The customer name is not valid",
      "PHONE_MISSING": "The phone number is required",
      "PHONE_INVALID": "The phone number is not valid"
    },
    "complete": "Complete the details",
    "dialogTitle": "Complete the customer's details",
    "dialogDescription": "Enter the customer's name and a valid mobile number to add movements to their accounts.",
    "nameLetters": "The name must contain Arabic or English letters",
    "completed": "The customer's details were completed successfully",
    "mergeTitle": "Move the accounts to the registered customer",
    "mergeDescription": "The phone number {{phone}} is registered to the customer {{name}}. This customer's accounts move under {{name}} as separate accounts. Each account keeps its balance, movements and statement.",
    "registeredCustomer": "Registered customer",
    "accountNamesTitle": "Account names under {{name}}",
    "accountNamesHelp": "Each name must differ from the accounts of {{name}} in the same branch.",
    "accountLabel": "Name of account {{number}}",
    "move": "Move the accounts",
    "changeNumber": "Change the number",
    "moved": "The accounts were moved to the customer {{name}} successfully"
  }
}
